import styled from "styled-components";

export const StyledManagePaths = styled.div`
  padding: 16px 0px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StyledManagePathsContainer = styled.div<{
  $isDraggingOver: boolean;
}>`
  display: flex;
  width: 100%;
`;

export const ContainerTitleGradePath = styled.div`
  display: flex;
  flex-direction: row;
  width: 97%;
  justify-content: space-between;
`;
